import { createSelector } from "@reduxjs/toolkit";
import { forms, IForm, patients } from "lobbie";
import { useSelector } from "react-redux";
import { LOBBIE_STORAGE } from "src/constants";
import { IAppState } from "src/redux";
import { sessionGet } from "src/utils";

const formGroupState = (state: IAppState) => state?.formGroup;

/**
 * Selectors
 */

const activeFormGroupSelector = createSelector([formGroupState], (formGroup) => {
    return formGroup;
});

const activeFormGroupIdSelector = createSelector([formGroupState], (formGroup) => {
    return formGroup?.id;
});

const activeFormGroupArchivedSelector = createSelector([formGroupState], (formGroup) => {
    return formGroup?.isArchived;
});

const activeFormGroupCompleteSelector = createSelector([formGroupState], (formGroup) => {
    return formGroup?.complete;
});

const activeFormGroupFormsSelector = createSelector([formGroupState], (formGroup) => {
    return formGroup?.forms || [];
});

const activeFormGroupAccountPatientSelector = createSelector([formGroupState], (formGroup) => {
    return formGroup?.accountPatient;
});
const activeFormGroupAccountPatientIdSelector = createSelector([formGroupState], (formGroup) => {
    return formGroup?.accountPatient?.id;
});

/**
 * Hooks
 */

export const useReduxActiveFormGroup = (): forms.IFormGroup | undefined => {
    return useSelector(activeFormGroupSelector);
};

export const useReduxActiveFormGroupForms = (): IForm[] => {
    return useSelector(activeFormGroupFormsSelector);
};

export const useReduxActiveFormGroupAccountPatient = ():
    | patients.IAccountPatientLite
    | undefined => {
    return useSelector(activeFormGroupAccountPatientSelector);
};

export const useReduxActiveFormGroupAccountPatientId = (): number | undefined => {
    return useSelector(activeFormGroupAccountPatientIdSelector);
};

export const useReduxActiveFormGroupId = (): number | undefined => {
    const stored = sessionGet(LOBBIE_STORAGE.Session.Patients.Forms.ActiveFormGroupId);
    return useSelector(activeFormGroupIdSelector) || (stored ? Number(stored) : undefined);
};

export const useReduxActiveFormGroupArchived = (): boolean => {
    return !!useSelector(activeFormGroupArchivedSelector);
};

export const useReduxActiveFormGroupComplete = (): boolean => {
    return !!useSelector(activeFormGroupCompleteSelector);
};
